module.exports = __webpack_public_path__ + "static/media/property.a12e0353.png";